import { ViewModal } from '@Components/index';
import { useAppDispatch } from '@Hooks/index';
import { modalActions } from '@Store/slices/modalSlice';
import { ViewTab } from '../../../ViewTab.enum';
import { DocumentViewModalContent } from '../../Section/DocumentItem';
import { MaterialViewModalContent } from '../../Section/MaterialItem';

interface ViewModalProps {
  showModal: boolean;
  activeTab: keyof typeof ViewTab;
}

const ItemViewModal: React.FC<ViewModalProps> = ({ showModal, activeTab }) => {
  const dispatch = useAppDispatch();

  return (
    <ViewModal
      isModalOpen={showModal}
      title="View Item"
      handleCancel={() => {
        dispatch(
          modalActions.setStatusModal({
            key: '',
            status: false,
            type: '',
          })
        );
      }}
    >
      {activeTab === ViewTab.DOCUMENTS && <DocumentViewModalContent />}
      {activeTab === ViewTab.MATERIALS && <MaterialViewModalContent />}
    </ViewModal>
  );
};

export default ItemViewModal;
